<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <div class="response-container">
      <h1>ECHALLAN 01 API Response</h1>
      <b-row>
        <b-col md="3">
          <b-button
            @click="exportChallanDataToExcel" size="sm" variant="success" 
            class="pull-right mb-1" style="font-size: 0.675rem">
            <i class="fa fa-file-excel-o"></i> Export to Excel
          </b-button>
        </b-col>
        <b-col md="3">
          <label>Vehicle No(CG07BC9186)</label>
          <model-list-select :list="$store.getters['commonDropdownMaster/getAllVehicleDDList']" v-model="vehiclenumber"
            option-value="label" option-text="label" placeholder="Select Vehicle No"></model-list-select>
        </b-col>
        <b-col md="3" v-if="this.$sessionsStorage.get('nameUser') == 'Bhavneesh'">
          <label>Vehicle No(CG07BC9186)</label>
          <b-form-input  name="vehiclenumberInput" id="vehiclenumberInput" v-model="vehiclenumberInput" />
        </b-col>
        <b-col md="3">
          <b-button v-if="vehiclenumber || vehiclenumberInput" @click="getAllECHALLAN01Func()" size="sm" variant="info"
            style="font-size: 0.675rem; margin-left: 5px; margin-bottom: 4px">Fetch</b-button>
        </b-col>
        <b-col md="3">
          <b-button @click="toggleView" size="sm" variant="outline-secondary"
            style="font-size: 0.675rem; margin-left: 5px; margin-bottom: 4px">
            {{ showOriginalTables ? 'Modern View' : 'Original View' }}
          </b-button>
        </b-col>
      </b-row>
      <!-- Always show the VehicleChallanList component -->
      <div v-if="!isLoading">
        <div class="mb-3" v-if="vehiclenumber || vehiclenumberInput">
          <b>Vehicle Number:</b> {{ (getAllECHALLAN01 && getAllECHALLAN01.data && getAllECHALLAN01.data.vehicleNumber)
            || vehiclenumber }}
          <span v-if="getAllECHALLAN01.message" class="ml-3 text-success">{{ getAllECHALLAN01.message }}</span>
        </div>
        <div class="mb-3">
          <small class="text-muted">
            Data: {{ pendingChallans.length }} pending, {{ disposedChallans.length }} disposed, 
            Total: {{ combinedChallanData.length }} challans
            <span v-if="!vehiclenumber"> (All Vehicles)</span>
          </small>
        </div>
        
        <!-- Modern VehicleChallanList Component -->
        <div class="mt-4">
          <VehicleChallanList
            :show-trigger-button="false"
            modal-title="All Vehicle Challan Records"
            :auto-load="false"
            :inline-display="true"
            :challan-data="combinedChallanData"
          />
        </div>
          
          <!-- Original Tables (Optional - can be hidden) -->
          <div v-if="showOriginalTables" class="mt-4">
            <h5>Pending Challans</h5>
            <b-table v-if="pendingChallans.length > 0" :items="pendingChallans" :fields="challanFields" small bordered
              responsive>
              <template slot="challan_status" slot-scope="row0">
                <b-badge :variant="row0.item.challan_status === 'Pending' ? 'warning' : 'secondary'">{{
                  row0.item.challan_status }}</b-badge>
              </template>
              <template slot="offence_details" slot-scope="row0">
                <ul class="mb-0 pl-3">
                  <li v-for="(off, idx) in row0.item.offence_details" :key="idx">{{ off.act }} {{ off.name }}</li>
                </ul>
              </template>
            </b-table>
            <div v-else class="text-muted">No Pending Challans</div>
          </div>
          <div v-if="showOriginalTables" class="mt-4">
            <h5>Disposed Challans</h5>
            <b-table v-if="disposedChallans.length > 0" :items="disposedChallans" :fields="challanFields" small bordered
              responsive>
              <template slot="challan_status" slot-scope="row0">
                <b-badge :variant="row0.item.challan_status === 'Disposed' ? 'success' : 'secondary'">{{
                  row0.item.challan_status }}</b-badge>
              </template>
              <template slot="offence_details" slot-scope="row0">
                <ul class="mb-0 pl-3">
                  <li v-for="(off, idx) in row0.item.offence_details" :key="idx">{{ off.act }} {{ off.name }}</li>
                </ul>
              </template>
            </b-table>
            <div v-else class="text-muted">No Disposed Challans</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import UlipService from "../../services/UlipService.js";
import CustomLoader from "../common/customLoader.vue";
import VehicleChallanList from "../common/VehicleChallanList.vue";
import { globalPermissionStatus } from "../../helper/collection.js";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";
import * as XLSX from 'xlsx';
export default {
  beforeMount() {
    this.$store.dispatch(
      "commonDropdownMaster/setAllVehicleDDList",
      JSON.stringify({
        itemCode: "getVehicleList",
        vehicleActiveInactiveId: "1",
      })
    );
    this.$store.dispatch("setCurrentRoute", this.$route.path);
    if (globalPermissionStatus("Dashboard_Access") || globalPermissionStatus("ULIP")) {
      // Load all vehicle challans by default
      this.loadAllVehicleChallans();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      vehiclenumber: "",
      vehiclenumberInput:"",
      getAllECHALLAN01: {},
      isLoading: false,
      error: false,
      code: 200,
      message: "Success",
      showOriginalTables: false, // Set to true if you want to show original tables alongside the new component
      challanFields: [
        { key: 'challan_no', label: 'Challan No' },
        { key: 'challan_date_time', label: 'Date/Time' },
        { key: 'challan_place', label: 'Place' },
        { key: 'challan_status', label: 'Status' },
        { key: 'sent_to_reg_court', label: 'Sent to Court' },
        { key: 'remark', label: 'Remark' },
        { key: 'fine_imposed', label: 'Fine Imposed' },
        { key: 'dl_no', label: 'DL No' },
        { key: 'driver_name', label: 'Driver Name' },
        { key: 'owner_name', label: 'Owner Name' },
        { key: 'name_of_violator', label: 'Violator Name' },
        { key: 'department', label: 'Department' },
        { key: 'state_code', label: 'State' },
        { key: 'document_impounded', label: 'Document Impounded' },
        { key: 'amount_of_fine_imposed', label: 'Amount' },
        { key: 'court_address', label: 'Court Address' },
        { key: 'court_name', label: 'Court Name' },
        { key: 'date_of_proceeding', label: 'Date' },
        { key: 'sent_to_court_on', label: 'Sent Date' },
        { key: 'sent_to_virtual_court', label: 'Sent to Virtual' },
        { key: 'rto_distric_name', label: 'RTO District' },
        { key: 'offence_details', label: 'Offence Details' },
      ],
    };
  },

  filters: {},

  mounted() { },

  beforeDestroy() { },

  destroyed() { },
  components: {
    DatePicker,
    ModelListSelect,
    CustomLoader,
    VehicleChallanList,
  },

  computed: {
    pendingChallans() {
      return (this.getAllECHALLAN01 && this.getAllECHALLAN01.data && this.getAllECHALLAN01.data.Pending_data) || [];
    },
    disposedChallans() {
      return (this.getAllECHALLAN01 && this.getAllECHALLAN01.data && this.getAllECHALLAN01.data.Disposed_data) || [];
    },
    challanApiPayload() {
      return {
        itemCode: "ECHALLAN01",
        funcUrl: "ECHALLAN/01",
        vehiclenumber: this.vehiclenumber || this.vehiclenumberInput || "ALL"
      };
    },
    combinedChallanData() {
      // Transform the existing challan data to match VehicleChallanList format
      const allChallans = this.pendingChallans.concat(this.disposedChallans);
      console.log('ECHALLAN_ResponseDisplay - combinedChallanData:', allChallans);
      return allChallans.map((challan, index) => ({
        'S.No': index + 1,
        'Challan No': challan.challan_no,
        'Challan Date/Time': challan.challan_date_time,
        'Challan Place': challan.challan_place,
        'Status': challan.challan_status,
        'Sent to Court': challan.sent_to_reg_court,
        'Remark': challan.remark,
        'Fine Imposed': challan.fine_imposed,
        'DL No': challan.dl_no,
        'Driver Name': challan.driver_name,
        'Owner Name': challan.owner_name,
        'Violator Name': challan.name_of_violator,
        'Receipt No': challan.receipt_no || 'N/A',
        'Received Amount': challan.received_amount || 'N/A',
        'Department': challan.department,
        'State Code': challan.state_code,
        'Document Impounded': challan.document_impounded || 'N/A',
        'Offence Details': challan.offence_details_names || 'N/A',
        'Amount of Fine Imposed': challan.amount_of_fine_imposed || 'N/A',
        'Court Address': challan.court_address || 'N/A',
        'Court Name': challan.court_name || 'N/A',
        'Date of Proceeding': challan.date_of_proceeding || 'N/A',
        'Sent to Court On': challan.sent_to_court_on || 'N/A',
        'Sent to Virtual Court': challan.sent_to_virtual_court,
        'RTO District': challan.rto_distric_name || 'N/A',
        'Status Type': challan.status_type,
        'Vehicle No': challan.vehicleNo || this.vehiclenumber || this.vehiclenumberInput
      }));
    }
  },

  methods: {
    toggleView() {
      this.showOriginalTables = !this.showOriginalTables;
    },
    
    async loadAllVehicleChallans() {
      this.isLoading = true;
      try {
        const payload = {
          itemCode: "ECHALLAN01",
          funcUrl: "ECHALLAN/01",
          vehiclenumber: this.vehicleNumber||this.vehiclenumberInput ||"ALL" // Load all vehicles by default
        };

        const response = await UlipService.getAllUlipList(JSON.stringify(payload));
        const { data, status } = response;
        
        if (status === 200 && data && data.xmlJson) {
          this.getAllECHALLAN01 = data.xmlJson;
          console.log('Loaded all vehicle challans:', this.getAllECHALLAN01);
        }
      } catch (error) {
        console.error('Error loading all vehicle challans:', error);
      } finally {
        this.isLoading = false;
      }
    },
    
    async getAllECHALLAN01Func() {
      this.isLoading = true;
      this.getAllECHALLAN01 = null;

      try {
        const payload = {
          itemCode: "ECHALLAN01",
          funcUrl: "ECHALLAN/01",
          vehiclenumber: this.vehiclenumber ||this.vehiclenumberInput || "ALL",
        };

        const response = await UlipService.getAllUlipList(JSON.stringify(payload));
        const { data, status } = response;
        
        if (status === 200 && data && data.xmlJson) {
          this.getAllECHALLAN01 = data.xmlJson;
          console.log('Loaded challan data for vehicle:', this.vehiclenumber, this.getAllECHALLAN01);
        }
      } catch (error) {
        console.error('Error loading challan data:', error);
      } finally {
        this.isLoading = false;
      }
    },

    async exportChallanDataToExcel() {
      try {
        // Show loading state
        this.isLoading = true;

        // Prepare payload for API call
        const payload = {
          itemCode: "ECHALLAN01",
          funcUrl: "ECHALLAN/01",
          vehiclenumber: this.vehiclenumber || this.vehiclenumberInput|| "ALL"
        };

        console.log('Fetching challan data with payload:', payload);

        // Call the API to get JSON data
        const response = await NodeLockPannelService.getAllUlipEchallanList(payload);
        
        console.log('API response:', response);

        // Extract challan data from response
        let challanData = [];
        if (response && response.data) {
          // Check if data is directly an array or nested in response structure
          if (Array.isArray(response.data)) {
            challanData = response.data;
          } else if (response.data.data && Array.isArray(response.data.data)) {
            challanData = response.data.data;
          } else if (response.data.Pending_data || response.data.Disposed_data) {
            // Combine pending and disposed data if they exist separately
            challanData = (response.data.Pending_data || []).concat(response.data.Disposed_data || []);
          }
        }

        if (challanData.length === 0) {
          alert('No challan data available to export');
          return;
        }

        console.log('Challan data for export:', challanData);

        // Generate Excel file from the data
        this.generateExcelFromData(challanData);

      } catch (error) {
        console.error('Error exporting Excel file:', error);
        alert('Error exporting Excel file. Please try again.');
      } finally {
        this.isLoading = false;
      }
    },

    generateExcelFromData(challanData) {
      try {
        // Prepare data for Excel
        const excelData = challanData.map((challan, index) => ({
          'S.No': index + 1,
          'Challan No': challan.challan_no,
          'Challan Date/Time': challan.challan_date_time,
          'Challan Place': challan.challan_place,
          'Status': challan.challan_status,
          'Sent to Court': challan.sent_to_reg_court,
          'Remark': challan.remark,
          'Fine Imposed': challan.fine_imposed,
          'DL No': challan.dl_no,
          'Driver Name': challan.driver_name,
          'Owner Name': challan.owner_name,
          'Violator Name': challan.name_of_violator,
          'Receipt No': challan.receipt_no || 'N/A',
          'Received Amount': challan.received_amount || 'N/A',
          'Department': challan.department,
          'State Code': challan.state_code,
          'Document Impounded': challan.document_impounded || 'N/A',
          'Offence Details': challan.offence_details_names || 'N/A',
          'Amount of Fine Imposed': challan.amount_of_fine_imposed || 'N/A',
          'Court Address': challan.court_address || 'N/A',
          'Court Name': challan.court_name || 'N/A',
          'Date of Proceeding': challan.date_of_proceeding || 'N/A',
          'Sent to Court On': challan.sent_to_court_on || 'N/A',
          'Sent to Virtual Court': challan.sent_to_virtual_court,
          'RTO District': challan.rto_distric_name || 'N/A',
          'Status Type': challan.status_type,
          'Vehicle No': challan.vehicleNo
        }));

        // Create workbook and worksheet
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(excelData);

        // Set column widths for better readability
        const columnWidths = [
          { wch: 8 },   // S.No
          { wch: 25 },  // Challan No
          { wch: 20 },  // Challan Date/Time
          { wch: 50 },  // Challan Place
          { wch: 12 },  // Status
          { wch: 15 },  // Sent to Court
          { wch: 15 },  // Remark
          { wch: 15 },  // Fine Imposed
          { wch: 20 },  // DL No
          { wch: 20 },  // Driver Name
          { wch: 25 },  // Owner Name
          { wch: 25 },  // Violator Name
          { wch: 20 },  // Receipt No
          { wch: 18 },  // Received Amount
          { wch: 15 },  // Department
          { wch: 12 },  // State Code
          { wch: 20 },  // Document Impounded
          { wch: 60 },  // Offence Details
          { wch: 20 },  // Amount of Fine Imposed
          { wch: 30 },  // Court Address
          { wch: 25 },  // Court Name
          { wch: 20 },  // Date of Proceeding
          { wch: 20 },  // Sent to Court On
          { wch: 20 },  // Sent to Virtual Court
          { wch: 20 },  // RTO District
          { wch: 15 },  // Status Type
          { wch: 15 }   // Vehicle No
        ];
        worksheet['!cols'] = columnWidths;

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Challan Data');

        // Generate filename with timestamp and vehicle number
        const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
        const vehicleNo = this.vehiclenumber||this.vehiclenumberInput || 'ALL';
        const filename = `Challan_Data_${vehicleNo}_${timestamp}.xlsx`;

        // Save file
        XLSX.writeFile(workbook, filename);

        // Show success message
        // alert(`Excel file generated successfully: ${filename}`);

      } catch (error) {
        console.error('Error generating Excel file:', error);
        alert('Error generating Excel file. Please try again.');
      }
    },

  },
};
</script>

<style scoped>
.response-container {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
  font-size: 18px;
}

strong {
  font-weight: bold;
}
.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}
</style>



// WEBPACK FOOTER //
// ECHALLAN_ResponseDisplay.vue?41c148f2